import { useRef } from 'react';

export default function SearchBar({ value, onChange, placeholder = 'Pretraži proizvode…' }) {
  const inputRef = useRef(null);

  return (
    <div className="relative w-full max-w-md">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full border rounded pl-4 pr-10 py-2"
      />
      {/* Magnifier (pure CSS bars)
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">🔎</span> */}

      {value && (
        <button
          type="button"
          onClick={() => {
            onChange('');
            inputRef.current?.focus();
          }}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
          aria-label="Clear search"
          title="Clear"
        >
          ×
        </button>
      )}
    </div>
  );
}
